module.exports = __webpack_public_path__ + "img/12.56ae6252.jpg";